/* eslint-disable import/exports-last */
import type { TableConfig } from '../../types'

export const ActionTypes = {
  Init: '@@INIT',
  SetData: 'SET_DATA',
  SetConfig: 'SET_CONFIG',
} as const

export type ConfigUpdate<T extends Record<string, unknown>> = Omit<
  TableConfig<T>,
  'data' | 'className' | 'scrollToEndLabel'
>

interface ISetDataAction<T extends Record<string, unknown>> {
  type: typeof ActionTypes.SetData
  payload: T[]
}

interface ISetConfigAction<T extends Record<string, unknown>> {
  type: typeof ActionTypes.SetConfig
  payload: ConfigUpdate<T>
}

interface IInitAction<T extends Record<string, unknown>> {
  type: typeof ActionTypes.Init
  payload: {
    data: T[]
    config: ConfigUpdate<T>
  }
}

export class SetDataAction<T extends Record<string, unknown>> implements ISetDataAction<T> {
  readonly type = ActionTypes.SetData
  readonly payload: T[]

  constructor(payload: T[]) {
    this.payload = payload
  }
}

export class SetConfigAction<T extends Record<string, unknown>> implements ISetConfigAction<T> {
  readonly type = ActionTypes.SetConfig
  readonly payload: ConfigUpdate<T>

  constructor(payload: ConfigUpdate<T>) {
    this.payload = payload
  }
}

export class InitAction<T extends Record<string, unknown>> implements IInitAction<T> {
  readonly type = ActionTypes.Init
  readonly payload: {
    data: T[]
    config: ConfigUpdate<T>
  }

  constructor(payload: { data: T[]; config: ConfigUpdate<T> }) {
    this.payload = payload
  }
}

export type TableAction<T extends Record<string, unknown>> = SetDataAction<T> | SetConfigAction<T> | InitAction<T>
